import algoliasearch from 'algoliasearch';

export const algoliaClient = algoliasearch(process.env.REACT_APP_ALGOLIA_APP_ID, process.env.REACT_APP_ALGOLIA_API_KEY);

export const vendorsIndex = algoliaClient.initIndex(process.env.REACT_APP_ALGOLIA_VENDORS_INDEX);
export const trucksIndex = algoliaClient.initIndex(process.env.REACT_APP_ALGOLIA_TRUCKS_INDEX);
export const paymentsIndex = algoliaClient.initIndex(process.env.REACT_APP_ALGOLIA_PAYMENTS_INDEX);
export const campaignsIndex = algoliaClient.initIndex(process.env.REACT_APP_ALGOLIA_CAMPAIGNS_INDEX);
